module.exports = __webpack_public_path__ + "img/18.69c9500c.png";